import React, { useState } from "react";
import AdminHeader from "./AdminHeader";
import AdminNavbar from "./AdminNavbar";
import { Link } from "react-router-dom";
const AdminBetlist = () => {
  return (
    <div>
      <AdminHeader />
      <AdminNavbar />
      <div className="commision bg-[#f0ece1] fixed_width h-[100vh]  ">
        <div className="   ">
          <h2 className="font-bold text-black py-2 px-4">Bet List</h2>
        </div>
        <div className="bg-[#dff1f8] border-b-2 border-[#498daf] shadow-md   ml-4   w-[98%]">
          <div className=" mt-2 px-3 py-2 flex">
            <label htmlFor="" className="mr-3">
              Sport:
            </label>
            <select name="" className="w-[120px] text-[20px]">
              <option value="" className="">
                Cricket
              </option>
              <option value="">Tennis</option>
              <option value="">Soccer</option>
            </select>
            <div className="flex items-center">
              <p className="text-[12px] ml-3">Period</p>
              <input
                type="date"
                className="mx-2 py-1 px-2 border-gray-400 border-1 "
                id="birthday"
                name="birthday"
              ></input>
              <input
                type="text"
                className="w-[60px] py-1 border-1 border-gray-400"
                placeholder="9:00"
              />
              <p className="">To</p>
              <input
                type="date"
                className="mx-2 py-1 px-2 border-gray-400 border-1 "
              ></input>
              <input
                type="text"
                className="py-1 w-[60px] border-1 border-gray-400"
                placeholder="9:00"
              />
            </div>
          </div>
          <div className="ml-4">
            <button
              className="text-[12px]  border-gray-400 border-1  rounded px-3 py-1 mt-2 font-medium
              bg-[#fff]
          "
            >
              Just For Today
            </button>
            <button
              className="text-[12px]  border-gray-400 border-1  py-1 mx-1 rounded px-3 mt-2 font-medium
              bg-[#fff]
          "
            >
              Just For Today
            </button>
            <button
              className="text-[12px]  border-gray-400 border-1  py-1 mx-1 rounded px-3 mt-2 font-bold
              bg-[#ffaa50] w-[120px]
          "
            >
              Get Matches
            </button>
            <div className="flex items-center mt-2 pb-3">
              <p className="">Bet Status:</p>
              <select
                name=""
                id=""
                className="mx-2 w-[120px] px-2 border-gray-400 border-1 "
              >
                <option value="">settled</option>
              </select>
              <button
                className="text-[12px]  border-gray-400 border-1  py-1 mx-4 rounded px-3 mt-2 font-bold
                bg-[#ffaa50] w-[120px]
          "
              >
                Filter Bets
              </button>
            </div>
          </div>
        </div>
        <div className="px-4  mt-3">
          <h2 className="text-[14px] mb-1">
            Betting History enables you to review the bets you have placed.
          </h2>
          <h2 className="text-[14px] mb-1">
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </h2>
          <h2 className="text-[14px] mb-1">
            Specify the time period during which your bets were placed, the type
            of markets on which the bets were placed, and the sport.
          </h2>
        </div>
      </div>
    </div>
  );
};

export default AdminBetlist;
